import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAuth} from '../store/AuthProvider';
import {LoadingAnimation} from '../components/loading-animation/LoadingAnimation';
import {RootRoute} from './RootRoute';
import {useAppSelector} from '../hooks/store/useAppSelector';
import {UserSelector} from '../store/user/UserSelector';
import {CompanySelector} from '../store/company/CompanySelector';
import {EnvironmentDownScreen} from '../components/environment-down-screen/EnvironmentDownScreen';

const NavigateToLogin = () => {
  return (
    <Navigate
      to={`${RootRoute.LogIn}?returnUrl=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`}
      replace
    />
  );
};

export const ProtectedUserRoute = () => {
  const {user, isLoading} = useAuth();
  const location = useLocation();
  const isVerifyRoute = location.pathname === RootRoute.SignUpVerifyEmail;
  const isGetStartedRoute = location.pathname === RootRoute.GetStarted;

  const userDetails = useAppSelector(UserSelector.getUserDetails);
  const companyDetails = useAppSelector(CompanySelector.getCompanyDetails);
  if (isLoading) {
    return <LoadingAnimation overwriteIsBusy />;
  }

  if (!user) {
    return <NavigateToLogin />;
  }

  // Check if user is in get-started flow
  if (userDetails && userDetails.companyId === 'UNKNOWN_COMPANY') {
    // Only allow get-started and verify email routes
    if (!isGetStartedRoute && !isVerifyRoute) {
      return <Navigate to={RootRoute.GetStarted} replace />;
    }
    return <Outlet />;
  }

  const isPasswordProvider =
    user?.providerData?.[0]?.providerId === 'password' ? true : false;

  if (user && !user.emailVerified && isPasswordProvider) {
    if (!isVerifyRoute) {
      return (
        <Navigate
          to={RootRoute.SignUpVerifyEmail}
          replace
          state={{email: user.email ?? undefined}}
        />
      );
    }

    return <Outlet />;
  }

  if (!userDetails && user) {
    return <LoadingAnimation overwriteIsBusy />;
  }

  const environmentDown = companyDetails?.settings?.isEnvironmentDown;
  if (environmentDown) {
    return (
      <EnvironmentDownScreen
        title={environmentDown.title}
        description={environmentDown.description}
      />
    );
  }

  return <Outlet />;
};
